import { render } from "./KakaoRedirectPage.vue?vue&type=template&id=13a98906"
import script from "./KakaoRedirectPage.vue?vue&type=script&lang=js"
export * from "./KakaoRedirectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__